var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 77,
    viewBox: "0 0 126 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8887 83.5614L62.8474 25.332L62.8306 25.3164L27.8887 83.5614Z",
    fill: "url(#paint0_linear_27874_226539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.726 0H51.0209L0 83.5608H27.8894L62.8312 25.3158L62.8481 25.3314L76.4132 2.72464L74.726 0Z",
    fill: "url(#paint1_linear_27874_226539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5968 62.8867C55.7792 62.8867 53.1978 64.3502 51.8818 66.6544C50.2621 69.5036 42.1973 83.5628 42.1973 83.5628H126L76.4137 2.74219L62.8486 25.3489L85.8451 62.8244L58.5968 62.9022V62.8867Z",
    fill: "url(#paint2_linear_27874_226539)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27874_226539",
    x1: 45.3681,
    y1: -63.0219,
    x2: 45.3681,
    y2: 123.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27874_226539",
    x1: 38.2066,
    y1: -126.734,
    x2: 38.2066,
    y2: 141.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27874_226539",
    x1: 84.0989,
    y1: -119.836,
    x2: 84.0989,
    y2: 139.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoIcon);
export default __webpack_public_path__ + "static/media/Auto_Icon.03b990999fd0b7d96d1f951a725d3906.svg";
export { ForwardRef as ReactComponent };